import ICONS_LIST from '@convenia/components/CIcon/stories/iconList.json'

export const THEMES = [
  'primary',
  'positive',
  'alert',
  'negative',
  'support',
  'disabled',
  'compl-2',
  'positive-2',
]

/**
 * Checks if the provided value is a valid icon.
 *
 * @param {string} [value=''] - The value to check against the icon list.
 * @returns {boolean} - Returns true if the value is a valid icon, otherwise false.
 */
export const isValidIcon = (value = '') => {
  return !!value && ICONS_LIST.includes(value)
}

/**
 * Checks if the given value is a valid theme.
 *
 * @param {string} [value=''] - The theme value to validate.
 * @returns {boolean} True if the value is a valid theme, false otherwise.
 */
export const isValidTheme = (value = '') => {
  return !!value && THEMES.includes(value)
}
